import { IContainer } from '../../../json-parse/src/interface'
import { DROP_LAYOUT_EL, DROP_CONTAINER_ACTIVE_CLASSNAME } from '../../../json-parse/src/tools/const'
import { containerMethods } from './quickBar'
import UEI from '../use/useEditInfo'
import deepcopy from 'deepcopy'

// 作为容器的逻辑开始-----------------------------------------------------------------------------
let flag = true // 防抖开关
let currentContainerElement: HTMLElement | undefined // 当前的容器元素节点
let currentContainerLayout: IContainer | undefined // 当前的容器元素节点携带的布局信息

// 从左侧拖拽带容器中
export const dragIntoContainer = {
  timer: undefined, // 防抖定时器
  // 获取模板元素
  activeElement(event: any) {
    if (event.target) {
      const tempElement: HTMLElement | undefined = containerMethods.findUserfulContainerParent(event.target, true)
      const tempLayout = tempElement && (tempElement as any)[DROP_LAYOUT_EL]
      if (!tempElement || !tempLayout) return
      currentContainerElement = tempElement
      currentContainerLayout = tempLayout
      // 非叶子节点才能作为容器，添加背景样式
      currentContainerElement.classList.add(DROP_CONTAINER_ACTIVE_CLASSNAME.inner)
    }
  },
  // 删除模板元素
  cancelElement(event: any) {
    currentContainerElement = undefined
    currentContainerLayout = undefined
  },
  // 正坐在拖拽
  dragOver(event: any) {
    event.preventDefault()
    if (flag) {
      dragIntoContainer.activeElement(event)
      flag = false
      ;(dragIntoContainer.timer as any) = setTimeout(() => {
        flag = true
      }, 500)
    }
  },
  // 进入容器
  dragEnter(event: any) {
    if (UEI.clickElement) {
      ;(UEI.clickElement as any).classList.remove(DROP_CONTAINER_ACTIVE_CLASSNAME.moving)
    }
    dragIntoContainer.activeElement(event)
    event.preventDefault()
  },
  // 离开容器
  dragLeave(event: any) {
    dragIntoContainer.clearDropOverEffect(false, event)
  },
  // 按键松开，目标放下
  dragDrop(event: any) {
    dragIntoContainer.clearDropOverEffect(true, event)
  },
  // 清除拖拽离开的副作用
  clearDropOverEffect(isDragDrop = false, event: any) {
    dragIntoContainer.activeElement(event)
    if (currentContainerElement && currentContainerLayout && UEI.state.dropedLayout) {
      currentContainerElement.classList.remove(DROP_CONTAINER_ACTIVE_CLASSNAME.inner)
      if (isDragDrop) {
        let tempLayout = { ...UEI.state.dropedLayout }
        if (tempLayout) {
          if (toString.call(tempLayout.styleConfig) !== '[object Object]') tempLayout.styleConfig = {}
          if (tempLayout.styleConfig && !['relative', 'static'].includes(tempLayout.styleConfig.position + '')) {
            tempLayout.styleConfig.left = parseInt(event.offsetX - tempLayout.xRelative + '')
            tempLayout.styleConfig.top = parseInt(event.offsetY - tempLayout.yRelative + '')            
            // tempLayout.styleConfig.left = event.offsetX
            // tempLayout.styleConfig.top = event.offsetY
          }
          delete tempLayout.xRelative
          delete tempLayout.yRelative
          containerMethods.targetDrop(currentContainerElement, deepcopy(tempLayout))
          setTimeout(() => {
            UEI.setDotrectInfo()
          })
        }
      }
    }
    dragIntoContainer.cancelElement(event)
  }
}
